import { useParams } from "react-router-dom";
import { getRideDetails } from "services/auth/rideApis";
import { useEffect, useState } from "react";
import { RequestBar } from "../components/RequestBar";
import { EditRideCard } from "../components/EditRideCard";
import { RideDetailsCard } from "../components/RideDetailsCard";
import { ApprovalPanel } from "../components/ApprovalPanel";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export const HostRide = () => {
    const { id } = useParams();
    const [ride, setRide] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editActive, setEdit] = useState(false);
    const navigate = useNavigate()

    const fetchRideDetails = async () => {
        try {
            setLoading(true);
            toast.loading("Loading ride details...");
            const data = await getRideDetails(id);
            toast.dismiss();
            if (!data) {
                navigate("/my-rides")
            }
            else {
                setRide(data);
            }
        } catch (error) {
            console.error("Failed to fetch ride details:", error);
            toast.dismiss();
            toast.error("Failed to load ride details");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            fetchRideDetails();
        }
    }, [id, editActive]);

    if (loading) {
        return (
            <div className="w-screen hideScrollBars overflow-y-scroll overflow-x-hidden flex-1 backdrop-blur max-sm:backdrop-blur-sm py-5 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mx-auto"></div>
                    <p className="mt-4 text-zinc-600">Loading ride details...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-screen hideScrollBars overflow-y-scroll overflow-x-hidden flex-1 backdrop-blur max-sm:backdrop-blur-sm py-5">
            <div className="max-w-[90vw] w-full backdrop-blur mx-auto overflow-x-auto rounded-3xl border-[1px] p-2 bg-white/90">
                {ride && (
                    <div className="flex max-md:flex-col items-baseline max-md:items-center md:gap-4 min-h-[60vh] w-full">
                        <div className="flex-1 flex flex-col justify-stretch w-full">
                            {editActive ? (
                                <EditRideCard setEdit={setEdit} rideDetails={ride} onRideUpdated={fetchRideDetails} />
                            ) : (
                                <RideDetailsCard setEdit={setEdit} ride={ride} onRideUpdated={fetchRideDetails} />
                            )}
                        </div>
                        <div className="flex-1 w-full max-md:w-full max-md:border-t-white max-md:border-t-[1px] max-md:border-l-0 border-l-white border-l-[1px] flex flex-col justify-stretch">
                            {ride.Request.length > 0 ? (
                                <>
                                    <h1 className="text-2xl font-semibold text-center border-b border-zinc-300 p-4">
                                        Requests
                                    </h1>
                                    <div className="flex-1 flex flex-col justify-stretch">
                                        {ride?.Request.map((request, i) => {
                                            return <RequestBar key={request._id || i} request={request} onStatusChange={fetchRideDetails} />;
                                        })}
                                    </div>
                                </>
                            ) : (
                                <div className="text-center max-md:h-[10vh] h-full w-full justify-center items-center flex">
                                    No requests made to this ride
                                </div>
                            )}
                            {ride.recurrenceGroupId && (
                                <ApprovalPanel recurrenceGroupId={ride.recurrenceGroupId} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};